/* eslint-disable prettier/prettier */
<template>
  <div class="user-center-temp-container">
    <div class="temp-header flex flex-between">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div>自定义腰带模板</div>
      <ul class="flex header-list">
        <li class="btn" @click="save">
          <span class="hmicon icon-baocun"></span>保存
        </li>
      </ul>
    </div>
    <div class="flex">
      <div class="component-list">
        <div class="title mb20">选择腰带模板</div>
        <div class="belt flex flex-wrap">
          <div
            class="belt-item pointer"
            :class="{ active: activeItem === i }"
            @click="selectBelt(v, i)"
            v-for="(v, i) in beltList"
            :key="i"
          >
            <div class="ad">
              <div class="belt-temp" :class="'temp' + (i + 1)">
                <img class="bg" :src="v.bg" />
              </div>
            </div>
            <div class="belt-name">模板{{ i + 1 }}</div>
          </div>
        </div>
      </div>
      <div class="preview-container flex flex-center">
        <div class="preview-wrapper text-center">
          <div class="title">自定义模板</div>
          <div class="preview">
            <belt
              :backgroundImage="backgroundImage"
              :index="activeItem + 1"
              :textList="textList"
            >
              <div slot="swiper" class="swiper"></div>
            </belt>
          </div>
        </div>
      </div>
      <div class="options-container">
        <div class="component-setting p20">
          <div class="caption">腰带属性</div>
          <div class="tips mt20 mb20">建议尺寸750x750像素或750x156像素</div>
          <div class="flex item-center mb20">
            <span class="title mr20">名称</span>
            <div class="content flex-1">
              <el-input
                style="width: 100%"
                size="small"
                placeholder="请输入自定义模板名称"
                v-model="templateName"
              ></el-input>
            </div>
          </div>
          <div class="bg-out-wrapper">
            <div class="bg-wrapper flex" @click="uploadImg">
              <img :src="backgroundImg" alt @click="uploadImg" />
              <div class="shade flex flex-center item-center">更换背景图</div>
            </div>
          </div>
          <div class="text-list">
            <div class="text-item" v-for="(v, i) in textList" :key="i">
              <div class="text-row flex flex-between item-center">
                <div>标题{{ i + 1 }}</div>
                <div>
                  <el-switch
                    v-model="v.show"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20">前缀</span>
                <div class="content flex-1">
                  <el-input
                    style="width: 100%"
                    size="small"
                    placeholder="请输入自定义模板名称"
                    v-model="v.title"
                  ></el-input>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20 tips">描述粗细</span>
                <div class="content flex item-center flex-1">
                  <div>
                    <span class="sub-title temp">
                      {{ v.titleFontWeight !== "normal" ? "加粗体" : "常规体" }}
                    </span>
                  </div>
                  <div class="item-setting flex flex-end flex-1">
                    <el-radio-group v-model="v.titleFontWeight">
                      <el-radio label="normal">
                        <div
                          class="shape blank flex item-center flex-center"
                          :class="{ active: v.titleFontWeight !== 'bold' }"
                        >
                          <span class="hmicon icon-wenzi-xi"></span>
                        </div>
                      </el-radio>
                      <el-radio label="bold">
                        <div
                          class="shape line flex item-center flex-center"
                          :class="{ active: v.titleFontWeight === 'bold' }"
                        >
                          <span class="hmicon icon-wenzi-cu"></span>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20 tips">标题颜色</span>
                <div class="content flex-1 text-right">
                  <el-color-picker
                    v-model="v.titleColor"
                    size="mini"
                    :predefine="predefine"
                  ></el-color-picker>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20 tips">文字大小</span>
                <div class="content flex-1 text-right">
                  <el-slider
                    :min="12"
                    :max="30"
                    size="small"
                    input-size="small"
                    :show-input-controls="false"
                    v-model="v.titleFontSize"
                  ></el-slider>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20">内容</span>
                <div class="content flex-1">
                  <el-select
                    style="width: 100%"
                    v-model="v.contentType"
                    class="flex-1"
                    size="small"
                    clearable
                    placeholder="选择内容"
                  >
                    <el-option label="活动时段" value="timeRange"></el-option>
                    <el-option label="倒计时" value="countDown"></el-option>
                    <el-option
                      label="到手价(仅对到手价标签生效)"
                      value="discountPrice"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20 tips">描述粗细</span>
                <div class="content flex item-center flex-1">
                  <div>
                    <span class="sub-title temp">
                      {{
                        v.contentFontWeight !== "normal" ? "加粗体" : "常规体"
                      }}
                    </span>
                  </div>
                  <div class="item-setting flex flex-end flex-1">
                    <el-radio-group v-model="v.contentFontWeight">
                      <el-radio label="normal">
                        <div
                          class="shape blank flex item-center flex-center"
                          :class="{ active: v.contentFontWeight !== 'bold' }"
                        >
                          <span class="hmicon icon-wenzi-xi"></span>
                        </div>
                      </el-radio>
                      <el-radio label="bold">
                        <div
                          class="shape line flex item-center flex-center"
                          :class="{ active: v.contentFontWeight === 'bold' }"
                        >
                          <span class="hmicon icon-wenzi-cu"></span>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20 tips">标题颜色</span>
                <div class="content flex-1 text-right">
                  <el-color-picker
                    v-model="v.contentColor"
                    size="mini"
                    :predefine="predefine"
                  ></el-color-picker>
                </div>
              </div>
              <div class="text-row flex item-center">
                <span class="title mr20 tips">文字大小</span>
                <div class="content flex-1 text-right">
                  <el-slider
                    :min="12"
                    :max="30"
                    size="small"
                    input-size="small"
                    :show-input-controls="false"
                    v-model="v.contentFontSize"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="show"
      v-if="show"
      noCircle
      noSquare
      :width="750"
      class="up"
      :height="156"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'mallDecoration' }"
      :url="$uploadUrl"
      img-format="png"
    >

    </my-upload>
    <div v-if="show" class="tip-red xx flex flex-center item-center">
      建议尺寸750x750像素或750x156像素
    </div>
  </div>
</template>

<script>
import belt from "@/components/belt";
import myUpload from "vue-image-crop-upload";
import { getCookie } from "../../utils/utils";
import { predefine, beltTempList } from "@/utils/tempData";

export default {
  components: {
    belt,
    myUpload
  },
  data() {
    return {
      predefine,
      activeItem: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      backgroundImage: "",
      show: false,
      templateName: "",
      textList: [],
      beltList: [],
      beltLayoutId: ""
    };
  },
  watch: {},
  created() {
    this.beltLayoutId = this.$route.query.beltLayoutId;
    this.queyTempList();
  },
  methods: {
    async queyTempList() {
      // const { result } = await this.$store.dispatch("queryBeltTempList", {
      //   pageNo: 1,
      //   pageSize: 9999
      // });
      // const { systemList } = result;
      this.beltList = beltTempList;
      this.selectBelt(this.beltList[this.activeItem], this.activeItem);
      this.backgroundImg = this.beltList[this.activeItem].tempImg;
      if (this.beltLayoutId) {
        const row = getCookie({ key: "BELT_TEMP_ROW", type: "session" });
        this.activeItem = this.beltList.findIndex(
          v => v.templateType === row.templateType
        );
        this.selectBelt(this.beltList[this.activeItem], this.activeItem);
        this.backgroundImg = row.backgroundImg;
        this.templateName = row.templateName;
      }
    },
    async editTemp() {
      const result = await this.$store.dispatch("operationTemp", {
        beltLayoutId: this.beltLayoutId,
        operationType: "edit",
        backgroundImg: this.backgroundImg,
        templateName: this.templateName,
        templateType: this.beltList[this.activeItem].templateType,
        previewComponents: JSON.stringify(this.textList)
      });
      if (result.code === "0") {
        this.back();
      }
    },
    uploadImg() {
      this.show = true;
    },
    cropUploadSuccess(jsonData) {
      this.backgroundImg = jsonData.result;
    },
    selectBelt(v, i) {
      this.activeItem = i;
      this.backgroundImage = v.tempImg;
      this.backgroundImg = this.backgroundImage;
      this.textList = this.beltList[this.activeItem].textList;
    },
    async save() {
      if (!this.templateName) {
        this.$message.warning("请输入模板名称");
        return;
      }
      if (!this.beltLayoutId) {
        const result = await this.$store.dispatch("addBeltTemp", {
          backgroundImg: this.backgroundImg,
          templateName: this.templateName,
          templateType: this.beltList[this.activeItem].templateType,
          previewComponents: JSON.stringify(this.textList)
        });
        if (result.code === "0") {
          this.back();
        }
      } else {
        this.editTemp();
      }
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>
<style lang="scss">
.xx {
  position: fixed;
  display: block;
  z-index: 10001;
  top: 55%;
  // bottom: 0;
  left: 0;
  right: 0;
  // position: relative;
  // .tip-red {
  //   position: absolute;
  //   top: 0;
  // }
}
</style>
<style lang="scss" scoped>
.preview {
  width: 375px;
  .swiper {
    width: 375px;
    height: 375px;
    background: #ffeaf3;
  }
  .belt-temp {
    height: 88px;
  }
}
.temp-header {
  height: 56px;
  line-height: 56px;
  background: #e50065;
  color: #fff;
  padding: 0 22px;
  font-size: 16px;
  user-select: none;
}
.title {
  margin-bottom: 20px;
}
.bg-wrapper {
  position: relative;
  .shade {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
    color: #fff;
    font-size: 12px;
    height: 24px;
  }
  img {
    width: 100%;
  }
}
.preview-container {
  position: fixed;
  top: 78px;
  left: 300px;
  right: 360px;
  bottom: 0;
  user-select: none;
}
.component-list {
  background: #fff;
  padding: 20px;
  width: 300px;
  height: 100vh;
  box-sizing: border-box;
}
.options-container {
  width: 360px;
  position: absolute;
  top: 56px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-bottom: 100px;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  bottom: 0;
  background: #fff;
}
.tips {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}

.belt {
  .belt-item {
    background: #fff;
    padding: 10px;
    margin-bottom: 10px;
    width: 100px;
    height: 120px;
    box-shadow: 0px 3px 32px 0px rgba(221, 221, 221, 0.58);
    &.active {
      opacity: 0.9;
      color: #e50065;
    }
    &:nth-child(n) {
      margin-right: 10px;
    }
    .bg {
      width: 100%;
    }

    .ad {
      position: relative;
      width: 100px;
      height: 100px;
      background: #ffeaf3;
      .belt-temp {
        position: absolute;
        bottom: 0;
        top: 0;
        &.temp2 {
          bottom: 0;
          top: unset;
        }
        img {
          vertical-align: middle;
        }
      }
    }

    .belt-name {
      padding: 10px;
      text-align: center;
      font-size: 12px;
    }
  }
}

.component-setting {
  .caption {
    font-weight: bold;
  }
  .title {
    margin-bottom: 0;
    font-size: 14px;
  }

  .bg-out-wrapper {
    margin-left: -20px;
    margin-right: -20px;
    padding: 20px;
    background: #f5f5f5;
  }
}
.text-list {
  margin-left: -20px;
  margin-right: -20px;
  .text-item {
    border-bottom: 1px solid #ddd;
    padding: 20px;

    .text-row {
      margin-top: 20px;
      .sub-title {
        font-size: 14px;
      }
    }
  }
  .shape {
    background: #fff;
    padding: 3px;
    width: 66px;
    height: 18px;
    box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
    .content {
      background: #ffeaf3;
      height: 100%;
      width: 100%;
    }
    &.active {
      background: #ffeaf3;
      border: 1px solid #e50065;
    }
    &.blank,
    &.line {
      width: 48px;
      height: 22px;
      font-size: 14px;
      text-align: center;
      box-shadow: none;
      .el-radio {
        margin-right: 0;
      }
    }
  }
}
</style>
